export function supportsFileSystemAccess(): boolean {
  return typeof window !== "undefined" && "showDirectoryPicker" in window
}

export async function pickDirectory(): Promise<FileSystemDirectoryHandle | null> {
  if (!supportsFileSystemAccess()) {
    return null
  }

  try {
    // showDirectoryPicker is still experimental in TypeScript's lib,
    // so we access it via the window object with a cast.
    const anyWindow = window as unknown as {
      showDirectoryPicker?: () => Promise<FileSystemDirectoryHandle>
    }

    if (!anyWindow.showDirectoryPicker) {
      return null
    }

    const handle = await anyWindow.showDirectoryPicker()
    return handle
  } catch (err) {
    // AbortError or user-cancel: treat as a benign cancel and return null.
    if (err instanceof DOMException && err.name === "AbortError") {
      return null
    }
    return null
  }
}


